import type { FeatureFlag } from "./FeatureFlag";

// Flag names must match the backend definitions in
// source/Commercial.Billing/Configuration/FeatureFlags.cs — the values are the keys
// returned by the /v2/configuration/features endpoint.
export const FeatureFlags = {
  AdoptionLedPricing: "AdoptionLedPricing",
} as const satisfies Record<string, FeatureFlag>;
